import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c756a9da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c756a9da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c756a9da')) {
      api.createRecord('c756a9da', component.options)
    } else {
      api.reload('c756a9da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c756a9da&scoped=true", function () {
      api.rerender('c756a9da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdybkzjl/index.vue"
export default component.exports